import { createFileRoute } from '@tanstack/react-router'
import { CreateMarket } from '@/features/trade/pool/CreateMarket'

export const Route = createFileRoute('/_app/pool/create-market')({
  component: CreateMarket,
})
